import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'debounce-promise';
import { httpsCallable } from 'firebase/functions';
import AsyncSelect from 'react-select/async';
import { functions } from '../firebase';

function SchoolField({ state, onChange }) {
  // eslint-disable-next-line consistent-return
  async function loadSchools(inputValue) {
    const q = inputValue;
    try {
      if (state !== '') {
        const response = await httpsCallable(functions, 'getSchoolsWithState')({ q, state });
        const { schools } = response.data;
        schools.push({ label: 'Other', value: 0 });
        return schools;
        // eslint-disable-next-line no-else-return
      } else {
        const response = await httpsCallable(functions, 'getSchoolsWithState')({ q, state: '' });
        return response.data.schools;
      }
    } catch (catchError) {
      // Intentionally skip error
    }
  }
  const loadSchoolsDebounce = debounce(loadSchools, 500);

  return (
    <AsyncSelect
      onChange={(e) => onChange(e)}
      loadOptions={loadSchoolsDebounce}
      required
      placeholder=""
      maxMenuHeight={120}
      classNamePrefix="school-select"
      noOptionsMessage={(query) => {
        if (!query.inputValue) {
          return 'Start typing to search for your school';
        }

        return 'No schools found.';
      }}
    />
  );
}

SchoolField.propTypes = {
  state: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SchoolField;
